module.exports = __webpack_public_path__ + "static/property-information-c2fa810d98474a2d3576ece2173723c1.png";